<up-chip-set>
  <ng-container>
    @for (chip of chips; track chip.id) {
      <up-chip
        chip-type="choice"
        [attr.selected]="isSelected(chip) ? '' : null"
        (selectedChanged)="onChipSelected(chip, $event)"
      >
        {{ chip.name }}
      </up-chip>
    }
  </ng-container>
</up-chip-set>